// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8c82ce48","455":"ca440a25","977":"87405c43"}[chunkId] + ".chunk.js";
};